import { render, staticRenderFns } from "./ListNiveles.vue?vue&type=template&id=8b5ea43c&scoped=true"
import script from "./ListNiveles.vue?vue&type=script&lang=js"
export * from "./ListNiveles.vue?vue&type=script&lang=js"
import style0 from "./ListNiveles.vue?vue&type=style&index=0&id=8b5ea43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5ea43c",
  null
  
)

export default component.exports